/* global $:false */

export default class ContactInfos {
  static init () {
    if (!($('.c-employee-selector').length > 0)) { return }

    $('.js-connected-sortable')
      .sortable({ connectWith: '.js-connected-sortable' })
      .disableSelection()
      .on('sortupdate', (e, ui) => {
        $('.js-not-selected input[type=hidden]').attr('disabled', true)
        $('.js-selected input[type=hidden]').attr('disabled', false)
        e.stopPropagation()
      })
  }
}
